import { HOST } from './Fetch';
import logo from '../assets/imgs/r-telecom_logo.png';

export const DEAFULTTITLE = 'Работа в ЭР-Телеком Холдинг'
export const DEAFULTIMAGE = HOST + logo



// WEBPACK FOOTER //
// ./src/constants/Meta.js